/*
 * @Descripttion: 带加号的 新建... 按钮
 * @Author: xutingting
 * @LastEditors: Please set LastEditors
 */
import React from 'react';
import styles from './index.module.scss';
import { Button } from '@alifd/next';
import plusPng from '@/assets/images/plus.png';

/**
 * @param 必传props: name 按钮名称 toCreateHandle 按钮点击触发的方法
 * @returns 一个带加号的新建按钮
 */
function index(props) {
    const { name, toCreateHandle, disable=false } = props;
    return (
        <div className={styles.wrap}>
            <Button type="primary" disabled={disable} className={styles.btn} onClick={toCreateHandle}>
                <img src={plusPng}/>
                {name}
            </Button>
        </div>
    );
}

export default index;
